var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

export class I18N extends Component {
  render() {
    const dictionary = this.props.dictionaries.toJS().find((d) => d.locale === this.props.locale) || {
      values: {}
    };
    let text = this.props.children;
    text = dictionary.values[text] || text;
    return /*#__PURE__*/_jsx("span", {}, void 0, text);
  }
}







const mapStateToProps = ({ locale, dictionaries }) => ({ locale, dictionaries });

export default connect(mapStateToProps)(I18N);